import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: '1. Information we collect',
    body: 'We collect the details you provide when you create an account or book an event — your name, phone number, and email — along with booking history and payment confirmation status. We do not store full card details; payments are processed by our PCI-compliant payment partner (Razorpay).',
  },
  {
    title: '2. How we use your information',
    body: 'Your information is used to confirm and manage bookings, send booking updates and receipts, provide customer support, prevent fraud, and improve the LocalKonnect experience. We may send you occasional offers, which you can opt out of at any time.',
  },
  {
    title: '3. Location data',
    body: 'With your permission we use your approximate location to show events and services relevant to your city. You can browse events anywhere in India; location is used only to personalize what you see and is never sold.',
  },
  {
    title: '4. Sharing',
    body: 'We share only what is necessary to fulfil a booking — for example, your name with the event organizer for entry. We never sell your personal data to third parties. Service providers such as SMS, payment, and analytics vendors process data on our behalf under contract.',
  },
  {
    title: '5. Data retention & security',
    body: 'We retain booking records for as long as your account is active and as required by law. Data is protected with encryption in transit and access controls. You may request deletion of your account and associated data at any time.',
  },
  {
    title: '6. Your rights',
    body: 'You can access, correct, or delete your personal information, and withdraw marketing consent. To exercise these rights, contact us at info@localkonnect.com or use the Delete Account page.',
  },
  {
    title: '7. Contact',
    body: 'Questions about this policy? Email info@localkonnect.com or call +91 9571364889. LocalKonnect, Bikaner, Rajasthan, India.',
  },
];

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-surface-muted">
      <Header />
      <main className="flex-1">
        <div className="border-b border-ink-200/70 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <h1 className="text-h1 text-ink-900">Privacy Policy</h1>
            <p className="mt-1 text-sm text-ink-500">Last updated: 19 August 2026</p>
          </div>
        </div>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <p className="text-ink-700 leading-relaxed mb-8">
            LocalKonnect ("we", "us") respects your privacy. This policy explains what we
            collect, how we use it, and the choices you have when you use our events platform.
          </p>
          <div className="space-y-8">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="text-lg font-semibold text-ink-900 mb-2">{s.title}</h2>
                <p className="leading-relaxed text-ink-700">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
